import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '@framework/i18n/i18n';
import { Modal } from '@framework/ui/elements/Modal';
type Props = {
  isOpen: boolean;
  onClose(): void;
};

export const LanguageSwitchModal: React.FC<Props> = ({ isOpen, onClose }: Props) => {
  const { t, i18n } = useTranslation();
  const handleChangeLanguage = useCallback(
    (lang: string) => {
      i18n.changeLanguage(lang);
      onClose();
    },
    [i18n, onClose]
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="p-6">
      <h2 className="mb-4 text-lg font-bold">{t('framework.language.label')}</h2>
      <div className="flex flex-col gap-2">
        {SUPPORTED_LANGUAGES.map(({ code, label }) => (
          <button
            key={code}
            onClick={() => handleChangeLanguage(code)}
            className={`rounded-md border px-4 py-3 text-left ${
              i18n.language === code
                ? 'border-blue-500 bg-blue-50 font-bold text-blue-700'
                : 'border-gray-200 text-gray-800 hover:bg-gray-100'
            }`}
          >
            {label}
          </button>
        ))}
      </div>
      <div className="mt-4 flex justify-end">
        <button onClick={onClose} className="rounded-md px-4 py-2 text-gray-600 hover:bg-gray-100">
          {t('common.action.close')}
        </button>
      </div>
    </Modal>
  );
};
